import { useLang } from "@/i18n/LanguageContext";

export const Marquee = () => {
  const { c } = useLang();
  const items = [...c.marquee, ...c.marquee];
  return (
    <section data-testid="editorial-marquee" className="overflow-hidden border-y border-paper/10 bg-deep py-10 md:py-16">
      <div className="marquee-track animate-marquee">
        {items.map((w, i) => (
          <span key={i} className="mx-8 font-serif text-[clamp(40px,8vw,120px)] uppercase leading-none tracking-tight md:mx-14">
            <span className={i % 2 === 0 ? "text-transparent" : "text-paper/90"} style={i % 2 === 0 ? { WebkitTextStroke: "1px rgba(80,180,160,0.6)" } : undefined}>
              {w}
            </span>
            <span className="mx-6 text-teal md:mx-10">·</span>
          </span>
        ))}
      </div>
    </section>
  );
};
